import { render, staticRenderFns } from "./EncyclopediaName.vue?vue&type=template&id=fdccbb8c&scoped=true"
import script from "./EncyclopediaName.vue?vue&type=script&lang=js"
export * from "./EncyclopediaName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdccbb8c",
  null
  
)

export default component.exports